<template>
  <div class="episode fade-in-fast" :class="currenPlaying ? 'current' : ''">
    <div class="episode__image">
      <div class="episode__image__tagline">
        <span>{{ currenPlaying ? 'Now Playing' : 'Episode' }}</span>
      </div>
      <div class="episode__image__play">
        <EpisodeButton
          class-name="episode__image__play__icon"
          :episode-title="episode.title"
          :episode-url="episode.showurl"
          :episode-permlink="episode.permlink"
          :artist="artist"
          @current-playing="isCurrent"
        />
      </div>
      <picture class="episode__image__thumb-container">
        <img
          class="episode__image__thumb-container__thumb"
          :src="$router.options.imagePath + episode.mediaUrl"
        />
      </picture>
    </div>
    <div class="episode__data">
      <div class="episode__data__wrapper">
        <div class="episode__data__header">
          <span>{{ sqlDateFormatted }}</span>
          <router-link :to="{name: 'location-id-episodes', params: {id: episode.location.locationname }}">
            {{ episode.location.locationname }}
          </router-link>
        </div>
        <router-link
          :to="{ name: 'Show', params: { id: episode.permlink } }"
          class="episode__data__heading"
        >
          <div class="episode__data__heading__title">
            {{ episode.title }}
          </div>
          <div class="episode__data__heading__subtitle">
            <template v-if="artistName && !episodeNameHasSameArtistName">
              <span>w/</span>
              <span>{{ episode.mainArtist.name }}</span>
            </template>
          </div>
        </router-link>
        <div v-if="$slots['episode-description']" class="episode__data__description">
          <slot name="episode-description" />
        </div>
      </div>
      <div v-if="episode.hasOwnProperty('subGenres') && $store.getters.getGenresState" class="episode__data__genres">
        <GenreButton v-for="genre in episode.subGenres"
                     :key="genre.id"
                     :genre="genre"
        />
      </div>
    </div>
  </div>
</template>
<script>
import EpisodeButton from '@/components/ui/EpisodeButton.vue';
import GenreButton from "@/components/genres/GenreButton";
export default {
  components: {
    EpisodeButton,
    GenreButton
  },

  props: {
    episode: {
      type: Object,
      required: true
    },
    artist: {
      type: Object,
      required: true
    },
    artistName: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currenPlaying: false
    };
  },

  computed: {
    sqlDateFormatted() {
      return this.episode.sqlDate
        .split('-')
        .reverse()
        .join('.');
    },

    episodeNameHasSameArtistName() {
      return String(this.episode.mainArtist.name).valueOf().trim() === String(this.episode.title).valueOf().trim();
    }
  },

  methods: {
    isCurrent(value) {
      this.currenPlaying = value;
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_episode-card.scss';
</style>
